import { IconSearch, SearchUser, TimesIcon } from '~misc/icons';
import React, { useState, useEffect } from 'react';
import {useSearchParams} from 'react-router-dom'

const FunnelClientSearch = ({
    showSearch = false,
  placeholder = 'Buscar Cliente, Razão Social e Grupo Centralizador',
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [internalValue, setInternalValue] = useState(searchParams.get('search') || '');

  useEffect(() => {
    setInternalValue(searchParams.get('search') || '');
  }, [searchParams]);

  const search = () => {
    const params = new URLSearchParams(searchParams);

    if (internalValue.trim()) {
      params.set('search', internalValue.trim());
    } else {
      params.delete('search');
    }

    setSearchParams(params);
    console.log(internalValue, typeof internalValue);
   
  };

  const handleSearch = (e) => {
    e.preventDefault();
    search();
  };

  const keyEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      search();
    }
  };

  const handleClearField = () => {
    setInternalValue('');
    const params = new URLSearchParams(searchParams);
    params.delete('search');
    setSearchParams(params);
   
  };
  return (
    <>
      {showSearch && (
        <div>
          <div className="flex gap-x-4 container bg-white p-5 border-terciaria border rounded-b-lg border-t-0 flex-col md:flex-row gap-y-4">
            <form action="" className="grow relative flex items-center" onSubmit={handleSearch}>
              <label className="absolute top-[28%] left-[10px] z-10 w-[23px] h-[23px]">
                <SearchUser />
              </label>
              <input
                className="input-search w-full py-5 px-10 rounded-lg border border-solid border-gray-300 placeholder-primaria text-16"
                type="text"
                value={internalValue}
                placeholder={placeholder}
                onChange={(e) => setInternalValue(e.target.value)}
                onKeyDown={keyEnter}
              />
              {internalValue.length > 0 && (
                <button className="absolute top-50 right-0 p-4 z-2" type="button" onClick={handleClearField}>
                  <TimesIcon />
                </button>
              )}
            </form>
            <button
              type="button"
              onClick={search}
              className="button-search grow md:grow-0 justify-center flex py-5 px-10 bg-primaria text-white rounded-lg gap-1 font-bold text-lg items-center"
            >
              Buscar
              <IconSearch fill="currentColor" className="ml-3 w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FunnelClientSearch;
